import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@1trading/react';
import type { ReactNode } from 'react';

export interface FieldValueRow {
  key: string;
  label: ReactNode;
  value: ReactNode;
}

interface FieldValueTableProps {
  rows: FieldValueRow[];
  /**
   * 'label' — human field labels (fx-swaps, questionnaires style);
   * 'code' — raw wire field names in mono (parked-deposits, transactions style,
   * where records may carry extra fields beyond the declared shape)
   */
  labelVariant?: 'label' | 'code';
  headings?: [string, string];
}

/**
 * Shared record-inspector Field/Value table. Callers keep their
 * domain renderValue/formatFieldValue functions and pass computed rows;
 * dialog callers own their scrollable `rounded-md border overflow-y-auto`
 * wrapper, embedded callers (pii-history, questionnaires) render it bare.
 */
export const FieldValueTable = ({ rows, labelVariant = 'label', headings = ['Field', 'Value'] }: FieldValueTableProps) => (
  <Table>
    <TableHeader>
      <TableRow>
        <TableHead>{headings[0]}</TableHead>
        <TableHead>{headings[1]}</TableHead>
      </TableRow>
    </TableHeader>
    <TableBody>
      {rows.map((row) => (
        <TableRow key={row.key}>
          <TableCell className={labelVariant === 'code' ? 'w-64 align-top font-mono text-xs' : 'whitespace-nowrap align-top font-medium'}>{row.label}</TableCell>
          <TableCell className="break-all">{row.value}</TableCell>
        </TableRow>
      ))}
    </TableBody>
  </Table>
);
FieldValueTable.displayName = 'FieldValueTable';
